import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/widgets/mouse';
import 'jquery-ui/ui/widgets/slider';

function createLegend(dateRange, monthsCount) {
	const yearsCount = dateRange.end.getYear() - dateRange.start.getYear() + 1;
	const contentElement = document.createElement('div');
	contentElement.className = 'date-range-chart-legend-content';

	for (let i = 0; i < yearsCount; i++) {
		const yearLegendElement = document.createElement('div');
		yearLegendElement.className = 'date-range-chart-legend-item';
		yearLegendElement.innerText = dateRange.start.getFullYear() + i;

		if (i === 0) {
			const width = (100 / (monthsCount - 1)) * (12 - dateRange.start.getMonth());
			yearLegendElement.style.width = `${width < 100 ? width : 100}%`;
		} else if (i === yearsCount - 1) {
			const width = (100 / (monthsCount - 1)) * (dateRange.end.getMonth() + 1);
			yearLegendElement.style.width = `${width < 100 ? width : 100}%`;
		} else {
			const width = (100 / (monthsCount - 1)) * 12;
			yearLegendElement.style.width = `${width < 100 ? width : 100}%`;
		}

		contentElement.appendChild(yearLegendElement);
	}

	const legendElement = document.createElement('div');
	legendElement.className = 'date-range-chart-legend';
	legendElement.appendChild(contentElement);
	return legendElement;
}

function createBars(dateRange, datasets) {
	const contentElement = document.createElement('div');
	contentElement.className = 'date-range-chart-content';

	const startTimestamp = dateRange.start.getTime();
	const endTimestamp = dateRange.end.getTime();
	const ratio = 100 / (endTimestamp - startTimestamp);

	datasets.forEach((dataset) => {
		const barElement = document.createElement('a');
		barElement.className = 'date-range-chart-bar';
		barElement.innerText = dataset.name;
		barElement.href = dataset.sukl.link;

		const left = ratio * (dataset.start.getTime() - startTimestamp);
		barElement.style.left = `${left > 0 ? left : 0}%`;

		const width = ratio * (dataset.end.getTime() - dataset.start.getTime());
		barElement.style.width = `${width < 100 ? width : 100}%`;

		const linkElement = document.createElement('span');
		linkElement.className = 'block';
		linkElement.innerText = dataset.sukl.name;
		barElement.appendChild(linkElement);

		contentElement.appendChild(barElement);
	});

	return contentElement;
}

function createSlider(monthsCount, dateRange, onChange) {
	const contentElement = document.createElement('div');
	contentElement.className = 'date-range-chart-slider-content';

	const start = monthsCount - 37 > 0 ? monthsCount - 37 : 0;

	$(contentElement).slider({
		range: true,
		min: 0,
		max: monthsCount - 2,
		values: [start, monthsCount - 2],
		slide: function (event, ui) {
			const start = new Date(dateRange.start);
			start.setMonth(start.getMonth() + ui.values[0]);

			const end = new Date(dateRange.start);
			end.setMonth(end.getMonth() + ui.values[1] + 1);

			window.dateRange = { start, end };
			onChange({ start, end });
		},
		classes: {
			'ui-slider-handle': 'date-range-chart-handle',
			'ui-slider-range': 'date-range-chart-selected-range',
		},
	});

	const sliderElement = document.createElement('div');
	sliderElement.className = 'date-range-chart-slider';
	sliderElement.appendChild(contentElement);

	return sliderElement;
}

function dateToMonths(date) {
	return date.getFullYear() * 12 + date.getMonth();
}

function createDateRangeChart(element, dateRange, datasets, onChange) {
	const monthsCount = dateToMonths(dateRange.end) - dateToMonths(dateRange.start) + 1;

	const chartElement = document.createElement('div');
	chartElement.className = 'date-range-chart';
	chartElement.appendChild(createSlider(monthsCount, dateRange, onChange));
	chartElement.appendChild(createBars(dateRange, datasets));

	element.appendChild(createLegend(dateRange, monthsCount));
	element.appendChild(chartElement);
}

export { createLegend, createBars, createSlider, dateToMonths, createDateRangeChart };
